import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Mælkefri',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Stærk',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Vegansk',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Glutenfri',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Vegetarisk',
};
